var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E1EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3568_577622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.666 18V17.25C14.2518 17.25 13.916 17.5858 13.916 18H14.666ZM14.666 18.75H27.9993V17.25H14.666V18.75ZM30.5827 21.3333V28H32.0827V21.3333H30.5827ZM27.9993 30.5833H17.9993V32.0833H27.9993V30.5833ZM15.416 28V18H13.916V28H15.416ZM17.9993 30.5833C16.5726 30.5833 15.416 29.4267 15.416 28H13.916C13.916 30.2552 15.7442 32.0833 17.9993 32.0833V30.5833ZM30.5827 28C30.5827 29.4267 29.4261 30.5833 27.9993 30.5833V32.0833C30.2545 32.0833 32.0827 30.2552 32.0827 28H30.5827ZM27.9993 18.75C29.4261 18.75 30.5827 19.9066 30.5827 21.3333H32.0827C32.0827 19.0782 30.2545 17.25 27.9993 17.25V18.75Z",
    fill: "#3583EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3327 18.0001V18.7501C26.7469 18.7501 27.0827 18.4143 27.0827 18.0001H26.3327ZM14.666 18.0001H13.916C13.916 18.4143 14.2518 18.7501 14.666 18.7501V18.0001ZM17.9993 15.4167H22.9993V13.9167H17.9993V15.4167ZM26.3327 17.2501H14.666V18.7501H26.3327V17.2501ZM22.9993 15.4167C24.4261 15.4167 25.5827 16.5733 25.5827 18.0001H27.0827C27.0827 15.7449 25.2545 13.9167 22.9993 13.9167V15.4167ZM17.9993 13.9167C15.7442 13.9167 13.916 15.7449 13.916 18.0001H15.416C15.416 16.5733 16.5726 15.4167 17.9993 15.4167V13.9167Z",
    fill: "#3583EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.334 23L32.084 23C32.084 22.8011 32.005 22.6103 31.8643 22.4697C31.7237 22.329 31.5329 22.25 31.334 22.25V23ZM31.334 26.3333V27.0833C31.7482 27.0833 32.084 26.7475 32.084 26.3333H31.334ZM28.0007 23V23.75V23ZM28.0007 26.3333L28.0007 27.0833H28.0007V26.3333ZM30.584 23L30.584 26.3333L32.084 26.3333L32.084 23L30.584 23ZM31.334 25.5833H28.0007V27.0833H31.334V25.5833ZM28.0007 23.75L31.334 23.75V22.25L28.0007 22.25L28.0007 23.75ZM27.084 24.6667C27.084 24.1604 27.4944 23.75 28.0007 23.75L28.0007 22.25C26.666 22.25 25.584 23.332 25.584 24.6667L27.084 24.6667ZM28.0007 25.5833C27.4944 25.5833 27.084 25.1729 27.084 24.6667L25.584 24.6667C25.584 26.0014 26.666 27.0833 28.0007 27.0833L28.0007 25.5833Z",
    fill: "#3583EE"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F5FAFF",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3568_577622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.e12517b60e227c20635e338e70be6c16.svg";
export { ForwardRef as ReactComponent };